import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import productData from "../Datas/productData";
import "../css/orders.scss";

const Orders = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    // Load orders from localStorage
    const savedOrders = JSON.parse(localStorage.getItem("myOrders") || "[]");
    setOrders(savedOrders);
  }, []);

  const tabs = [
    { id: "all", label: "All" },
    { id: "pending", label: "Pending Payment" },
    { id: "processing", label: "Processing" },
    { id: "shipped", label: "Shipped" },
    { id: "completed", label: "Completed" },
  ];

  const filteredOrders =
    activeTab === "all"
      ? orders
      : orders.filter((order) => order.status === activeTab);

  const getStatusLabel = (status) => {
    const statusMap = {
      pending: "Pending Payment",
      processing: "Processing",
      shipped: "Shipped",
      completed: "Completed",
    };
    return statusMap[status] || status;
  };

  const getStatusClass = (status) => {
    const classMap = {
      pending: "status--pending",
      processing: "status--processing",
      shipped: "status--shipped",
      completed: "status--completed",
    };
    return classMap[status] || "";
  };

  const isVideo = (url) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="orders-page color-scheme color-scheme--scheme-1">
      <Header />
      <main className="orders-page__main">
        <div className="orders-container">
          <h1 className="orders-title">My Orders</h1>

          <div className="orders-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`orders-tab ${activeTab === tab.id ? "is-active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="orders-list">
            {filteredOrders.length === 0 ? (
              <div className="orders-empty">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="64" height="64">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
                </svg>
                <p>No orders found</p>
                <Link to="/shop" className="orders-empty__cta" onClick={toTop}>
                  Start Shopping
                </Link>
              </div>
            ) : (
              filteredOrders.map((order) => {
                const orderProducts = order.items
                  .map((item) => {
                    const product = productData.find((p) => p.id === parseInt(item.productId));
                    return product ? { ...product, ...item } : null;
                  })
                  .filter(Boolean);

                return (
                  <div key={order.id} className="order-card">
                    <div className="order-card__header">
                      <span className="order-id">Order #{order.id}</span>
                      <span className={`order-status ${getStatusClass(order.status)}`}>
                        {getStatusLabel(order.status)}
                      </span>
                    </div>

                    <div className="order-card__products">
                      {orderProducts.map((product) => (
                        <Link
                          key={product.id}
                          to={`/orderDetail/${order.id}`}
                          className="order-product"
                          onClick={toTop}
                        >
                          <div className="order-product__image">
                            {isVideo(product.images[0]) ? (
                              <video src={product.images[0]} autoPlay muted loop playsInline />
                            ) : (
                              <img src={product.images[0]} alt={product.name} />
                            )}
                          </div>
                          <div className="order-product__info">
                            <p className="order-product__name">{product.name}</p>
                            <p className="order-product__meta">
                              Size: {product.size} × {product.quantity}
                            </p>
                          </div>
                        </Link>
                      ))}
                    </div>

                    <div className="order-card__footer">
                      <span className="order-date">{order.date}</span>
                      <div className="order-total">
                        <span>Total:</span>
                        <span className="total-amount">
                          € {order.total.toFixed(2)}
                        </span>
                      </div>
                    </div>

                    <div className="order-card__actions">
                      {order.status === "pending" && (
                        <button type="button" className="action-btn action-btn--primary">
                          Pay Now
                        </button>
                      )}
                      {order.status === "shipped" && (
                        <Link
                          to={`/tracking/${order.id}`}
                          className="action-btn"
                          onClick={toTop}
                        >
                          Track Package
                        </Link>
                      )}
                      <Link
                        to={`/orderDetail/${order.id}`}
                        className="action-btn action-btn--outline"
                        onClick={toTop}
                      >
                        Order Details
                      </Link>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Orders;
